export default __webpack_public_path__ + "static/media/password-icon.54f93960.svg";